import { Platform } from "react-native";

/**
 * Common shadow styles used throughout the app
 */
export const Shadows = {
  /**
   * Card shadow - used for cards in My Money section
   */
  card: {
    shadowColor: "#6F6F6F",
    shadowOffset: { width: -3, height: 4 },
    shadowOpacity: 0.15,
    shadowRadius: 17,
    elevation: 3,
  },

  /**
   * Light shadow - subtle shadow for smaller elements
   */
  light: {
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 1,
  },

  /**
   * Medium shadow - for modals and elevated content
   */
  medium: {
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 4,
  },
};
